import classNames from 'classnames';
import { FunctionComponent } from 'react';

import { useWeblab } from '@amzn/sustainability-central-shared-react';

import { MenuItem } from 'src/components/common/menu-item/MenuItem';
import { useFooterNavItems } from 'src/components/footer/hooks/use-footer-nav-items';
import { NAV_MENU_IDS, NAV_PLACEMENT } from 'src/enums/navigation';
import { RESOURCE_BUNDLES } from 'src/enums/resource-bundles';
import { DEFAULT_THEME, useThemeConfig } from 'src/hooks/use-theme-config';

import styles from './Footer.module.scss';

/**
 * Items in the menu are flex positioned and right align is applied using "margin-left: auto".
 * The behavior is that every item starting with the one with the right align class
 * are shifted to the right. Keep in mind for NRS menu item ordering.
 */
const RIGHT_ALIGN_STARTING = NAV_MENU_IDS.COOKIE_POLICY;

export const Footer: FunctionComponent = () => {
  const { navItems } = useFooterNavItems();
  const { themeConfig } = useThemeConfig();
  const isThemeWeblabEnabled = useWeblab(themeConfig.weblab ?? '') === 'T1';

  // eslint-disable-next-line no-nested-ternary
  const themeValue = themeConfig.weblab
    ? isThemeWeblabEnabled
      ? themeConfig.value
      : DEFAULT_THEME.value
    : themeConfig.value;

  return (
    <footer className={classNames(styles.footer, styles[themeValue])}>
      <nav aria-label="secondary" className={styles.navigation}>
        <ul className={styles.listContainer}>
          {navItems.map((item) => (
            <MenuItem
              isAlignedRight={item.id === RIGHT_ALIGN_STARTING}
              key={item.id}
              navItem={item}
              placement={NAV_PLACEMENT.FOOTER}
              theme={themeValue}
              resourceBundle={RESOURCE_BUNDLES.FOOTER}
            />
          ))}
        </ul>
      </nav>
    </footer>
  );
};
